document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('customer_login_link');
  if (!el) return;
  el.addEventListener('click', function (e) {
    e.preventDefault();
    try { window.trackShopStats && trackShopStats('login_popup_view', 'all'); } catch (err) {}
    window.location.href = '/account';
  }, { capture: true });
});
